
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AccAdminComponent} from './acc-admin.component';
import {LoginGuard} from '../auth/login-guard';
import {CanDeactivateGuard} from '../helper/can-deactivate/can-deactivate.guard';

const accAdminRoutes = [
  {path: '', component: AccAdminComponent, canActivate: [LoginGuard], canDeactivate: [CanDeactivateGuard]}
];

@NgModule({
  imports: [
   RouterModule.forChild(accAdminRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AccAdminRoutingModule {}
